import { render, staticRenderFns } from "./NewPlaceOrder.vue?vue&type=template&id=447d6ac6&scoped=true&"
import script from "./NewPlaceOrder.vue?vue&type=script&lang=js&"
export * from "./NewPlaceOrder.vue?vue&type=script&lang=js&"
import style0 from "./NewPlaceOrder.vue?vue&type=style&index=0&id=447d6ac6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447d6ac6",
  null
  
)

export default component.exports